export const ACTION_NETWORK_ERROR_EVENT = 'action-network-error';
export const SERVER_UNREACHABLE_EVENT = 'server-unreachable';
export const REQUEST_TIMEOUT_MS = 30_000;
// Mirror of gunicorn `--timeout` (backend Procfile / Render start command).
// An action never gives up before the server does: a late client abort hides a completed write.
export const SERVER_WORKER_TIMEOUT_MS = 120_000;
export const ACTION_TIMEOUT_MARGIN_MS = 10_000;
export const ACTION_TIMEOUT_MS = SERVER_WORKER_TIMEOUT_MS + ACTION_TIMEOUT_MARGIN_MS;
// Gateway statuses. Our API answers them in JSON with a message (URSSAF timeout, Stripe off):
// only a non-JSON gateway page means the server itself is unreachable.
export const GATEWAY_FAILURE_STATUSES = Object.freeze([502, 503, 504]);
export const JSON_CONTENT_TYPE = 'application/json';
// Shared polling (useSharedPolling): owner re-election cadence and failure backoff.
export const POLL_ELECTION_MS = 5_000;
export const POLL_MAX_BACKOFF_MS = 5 * 60_000;
export const POLL_BACKOFF_MAX_DOUBLINGS = 4;
// Cross-tab token refresh: one tab refreshes (Web Lock), the others reuse its cookie session.
export const REFRESH_LOCK_NAME = 'neoprof:teacher-refresh';
export const REFRESH_REVISION_KEY = 'np_teacher_refresh_revision';
export const NETWORK_COPY = Object.freeze({
  offline: 'Aucune connexion Internet. Reconnectez-vous pour effectuer cette action.',
  timeout: 'Le serveur ne répond pas. Vérifiez le résultat avant de réessayer.',
  unavailable: 'Le serveur est injoignable. Veuillez réessayer dans un instant.',
});
